import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  featureListingPageTitle: 'تمييز الاعلان',
  featureListingTitle:
    'اختر نوع التمييز المناسب لإعلانك، وزِد فرص التواصل معك.',
  featureBestValue: 'الافضل قيمة',
  featureStatCalls: 'اتصالات',
  featureStatViews: 'مشاهدات',
  featureStatImpressions: 'ظهور',
  featureMultiplierValue: '{{value}}X',
  featureCreditDuration: '{{credit}} نقطة مقابل <tag>({{days}} يوم)</tag>',
  featureAmountDuration: '{{credit}} جنيه مقابل <tag>({{days}} يوم)</tag>',
  featureWithType: 'ميّز بـ {{name}}',
  featureConfirmQuestion: 'هل انت متأكد من تمييز {{name}} ؟',
  featureConfirmDescription:
    'سيتم خصم {{credit}} نقاط لتمييز هذا الإعلان لمدة {{days}} أيام',
  featureConfirmAction: 'تميّيز',
  featureNoCreditQuestion: 'ليس لديك رصيد كافي لتمييز {{name}} ؟',
  featureErrorTitle: 'حدث خطأ غير متوقع',
  featureErrorDescription: 'يرجي المحاولة مرة اخري',
  featurePaymentDetails: 'بيانات الدفع',
  featurePaymentSummary: 'ملخص الدفع',
  featurePrice: 'السعر',
});
